/**
 * cal-heatmap@3 is a UMD/CJS build without ESM default export.
 * Load it with a require() stub so d3 resolves to our Vite-safe shim.
 */
import d3 from 'd3'
import source from '../../../node_modules/cal-heatmap/cal-heatmap.min.js?raw'

const module = { exports: {} }
const require = (name) => {
    if (name === 'd3') return d3
    throw new Error('Cannot find module "' + name + '"')
}

const run = new Function(
    'module',
    'exports',
    'require',
    'window',
    `${source}\nreturn module.exports;`
)

const CalHeatMap = run(module, module.exports, require, globalThis)

export default CalHeatMap
